// extracted by mini-css-extract-plugin
export default {"error-text":"PrivacyContent_error-text__ggX5l","content-wrapper":"PrivacyContent_content-wrapper__ZgyBi","title":"PrivacyContent_title__2xtzA"};